import { defineNuxtPlugin } from '#app/nuxt'
import { LazyStrapiBlocksTextCodeNode, LazyStrapiBlocksTextImageNode, LazyStrapiBlocksTextParagraphNode, LazyStrapiBlocksTextQuoteNode, LazyStrapiBlocksTextHeading1Node, LazyStrapiBlocksTextHeading2Node, LazyStrapiBlocksTextHeading3Node, LazyStrapiBlocksTextHeading4Node, LazyStrapiBlocksTextHeading5Node, LazyStrapiBlocksTextHeading6Node, LazyStrapiBlocksTextBoldInlineNode, LazyStrapiBlocksTextCodeInlineNode, LazyStrapiBlocksTextItalicInlineNode, LazyStrapiBlocksTextLinkInlineNode, LazyStrapiBlocksTextListItemInlineNode, LazyStrapiBlocksTextStrikethroughInlineNode, LazyStrapiBlocksTextUnderlineInlineNode, LazyStrapiBlocksTextOrderedListNode, LazyStrapiBlocksTextUnorderedListNode, LazyStrapiBlocksText, LazyIcon, LazyIconCSS } from '#components'
const lazyGlobalComponents = [
  ["StrapiBlocksTextCodeNode", LazyStrapiBlocksTextCodeNode],
["StrapiBlocksTextImageNode", LazyStrapiBlocksTextImageNode],
["StrapiBlocksTextParagraphNode", LazyStrapiBlocksTextParagraphNode],
["StrapiBlocksTextQuoteNode", LazyStrapiBlocksTextQuoteNode],
["StrapiBlocksTextHeading1Node", LazyStrapiBlocksTextHeading1Node],
["StrapiBlocksTextHeading2Node", LazyStrapiBlocksTextHeading2Node],
["StrapiBlocksTextHeading3Node", LazyStrapiBlocksTextHeading3Node],
["StrapiBlocksTextHeading4Node", LazyStrapiBlocksTextHeading4Node],
["StrapiBlocksTextHeading5Node", LazyStrapiBlocksTextHeading5Node],
["StrapiBlocksTextHeading6Node", LazyStrapiBlocksTextHeading6Node],
["StrapiBlocksTextBoldInlineNode", LazyStrapiBlocksTextBoldInlineNode],
["StrapiBlocksTextCodeInlineNode", LazyStrapiBlocksTextCodeInlineNode],
["StrapiBlocksTextItalicInlineNode", LazyStrapiBlocksTextItalicInlineNode],
["StrapiBlocksTextLinkInlineNode", LazyStrapiBlocksTextLinkInlineNode],
["StrapiBlocksTextListItemInlineNode", LazyStrapiBlocksTextListItemInlineNode],
["StrapiBlocksTextStrikethroughInlineNode", LazyStrapiBlocksTextStrikethroughInlineNode],
["StrapiBlocksTextUnderlineInlineNode", LazyStrapiBlocksTextUnderlineInlineNode],
["StrapiBlocksTextOrderedListNode", LazyStrapiBlocksTextOrderedListNode],
["StrapiBlocksTextUnorderedListNode", LazyStrapiBlocksTextUnorderedListNode],
["StrapiBlocksText", LazyStrapiBlocksText],
["Icon", LazyIcon],
["IconCSS", LazyIconCSS],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
